import React from 'react'
import { ErrorPageLayout, Button } from 'react-angle-dashboard-components'

export const NotFound = () => {
  const onClick = () =>
    window.location.assign(
      'https://www.anglehealth.com/providers/provider-resources'
    )
  const button = (
    <Button onClick={onClick}>Go Back to Provider Resources</Button>
  )
  return (
    <ErrorPageLayout
      errorTitle="404: Page Not Found"
      errorSubtitle="The page you were looking for could not be found."
      button={button}
    ></ErrorPageLayout>
  )
}
